import HomeIcon from '@mui/icons-material/Home';
import GamepadIcon from '@mui/icons-material/Gamepad';
import CampaignIcon from '@mui/icons-material/Campaign';
import GroupIcon from '@mui/icons-material/Group';import { uuid } from './uuid';
import { PATHS } from '../routes/paths';
import { Person1 } from '../assets/img';

export const DUMMY_DATA = [
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 80,
    level: 10,
    isTwitterProfile: true,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 80,
    level: 11,
    isTwitterProfile: true,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: uuid(),
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
  {
    image: Person1,
    tokenHash: '33333',
    tokenAddress: uuid(),
    tokenId: uuid(),
    energy: 50,
    level: 12,
    isTwitterProfile: false,
    price: 100,
    twitter: 'Josh',
    age: '10 days',
  },
];

export const landingSliderData = [
  {
    id: uuid(),
    heading: 'We Wojakians',
    body: 'We are trusted by valid people such as Elon Musk and CZ.Also, We have gained the trust of more than 60k people.',
  },
  {
    id: uuid(),
    heading: 'We Wojakians',
    body: 'We are trusted by valid people such as Elon Musk and CZ.Also, We have gained the trust of more than 60k people.',
  },
  {
    id: uuid(),
    heading: 'We Wojakians',
    body: 'We are trusted by valid people such as Elon Musk and CZ.Also, We have gained the trust of more than 60k people.',
  },
];

export const thisWeekLandingData = {
  heading: 'this week in Woj Finance',
  body: 'General stats from the past 7 days in the Woj Finance.',
  cardsData: [
    {
      id: uuid(),
      title: 'New Feature',
      variable: '18,930',
    },
    {
      id: uuid(),
      title: 'New NFTs',
      variable: '212,420',
    },
    {
      id: uuid(),
      title: 'New Users',
      variable: '1929',
    },
  ],
};

export const SideBarData = [
  { id: uuid(), name: 'Home', icon: <HomeIcon />, path: PATHS.root },
  { id: uuid(), name: 'My Profile', icon: <GamepadIcon />, path: PATHS.games },
  { id: uuid(), name: 'Events', icon: <CampaignIcon />, path: PATHS.events },
  {
    id: uuid(),
    name: 'Sponsors',
    icon: <GroupIcon />,
    path: PATHS.activationCode,
  },
];
